module.exports = __webpack_public_path__ + "img/23_newYouth_wqq.4172e3b3.png";